import ErrorToast from "../../../../components/common/toasts/ErrorToast";
import React from "react";
import usePremiumResource from "../../hooks/usePremiumResource";
import { DictionaryType } from "../../constants";
import DictionaryRecordSave from "./DictionaryRecordSave";

/** Sprawdza bieżące uprawnienia i włączone słowniki firmy niezależnie od kopii zlecenia. */
export default function OrderDictionarySave({
  token,
  organizationId,
  target,
  value,
  disabled,
  label,
}) {
  const { data, error, reload } = usePremiumResource(
    token,
    `/organizations/${organizationId}`,
  );
  const company = data?.organization;
  const definitions = company?.manageDictionaries
    ? company.plugin.dictionaries.filter(
        (item) =>
          item.type === DictionaryType.RECORD &&
          item.selectionTarget === target &&
          item.keyField &&
          company.config[item.enabledBy],
      )
    : [];
  return (
    <>
      {definitions.map((definition) => (
        <DictionaryRecordSave
          key={`${organizationId}:${definition.kind}`}
          token={token}
          organizationId={organizationId}
          definition={definition}
          value={value}
          disabled={disabled}
          label={label}
        />
      ))}
      {error && (
        <div className="premium-record-save">
          <ErrorToast message={error} />
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={reload}
          >
            Sprawdź dostęp do słownika
          </button>
        </div>
      )}
    </>
  );
}
